//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations } from "vuex";

export default {
    name: "QfModel",
    data() {
        return {
            treeThumb: {
                right: "-3px", borderRadius: "2px", width: "3px", opacity: 0.4
            },
            selected: null,
            nodesExpanded: []
        };
    },
    computed: {
        ...mapState("components", ["properties", "activeComponent", "components"]),
        ...mapGetters("components", ["body"]),
        treeData() {
            const localData = { get: {}, set: {} };
            const treeData = [
                {
                    label: "GET", children: [], header: "path", icon: "mdi-database-export", key: "get", handler: this.nodeClick
                },
                {
                    label: "SET", children: [], header: "path", icon: "mdi-database-import", key: "set", handler: this.nodeClick
                }
            ];
            const mergeTreeData = (data, children, uniqPrefix) => {
                const addPath = (path, prefix) => {
                    let start = children; const partialPath = [];
                    const pathList = path.split(".");
                    const generateNode = nodePath => ({
                        header: "path", key: `${prefix}.${partialPath.join(".")}`, label: nodePath, handler: this.nodeClick, children: []
                    });

                    pathList.forEach(pathEntry => {
                        partialPath.push(pathEntry);
                        if (start.children.length) {
                            const node = start.children.find(child => child.label === pathEntry);
                            if (node) {
                                start = node;
                            } else {
                                const newNode = generateNode(pathEntry);
                                start.children.push(newNode);
                                start = newNode;
                            }
                        } else {
                            const newNode = generateNode(pathEntry);
                            start.children.push(newNode);
                            start = newNode;
                        }
                    });

                    return start;
                };

                Object.entries(data).forEach(([path, controls]) => {
                    const pathData = addPath(path, uniqPrefix);
                    pathData.children.push(...controls);
                });
            };

            Object.entries(this.properties).forEach(([guid, properties]) => {
                const configProperties = this.components[properties.__component];

                ["get", "set"].forEach(attribute => {
                    if (configProperties && properties && configProperties[attribute] && properties[attribute]) {
                        const newChild = {};
                        const modelPath = this.transformPath(properties[attribute]);

                        if (!localData[attribute].hasOwnProperty(modelPath)) {
                            localData[attribute][modelPath] = [];
                        }

                        newChild.header = "control";
                        newChild.key = guid;
                        newChild.label = properties.label || guid;
                        newChild.icon = configProperties.icon || "mdi-puzzle";
                        newChild.handler = this.nodeClick;
                        newChild.parentList = modelPath.split(".").reduce((accumulator, currentValue) => {
                            const last = accumulator.pop();
                            accumulator.push(last, `${last}.${currentValue}`);
                            return accumulator;
                        }, [attribute]);

                        localData[attribute][modelPath].push(newChild);
                    }
                });
            });

            ["get", "set"].forEach((attribute, idx) => {
                mergeTreeData(localData[attribute], treeData[idx], attribute);
            });

            // mergeTreeData(localData.get, treeData[0], "get");
            // mergeTreeData(localData.set, treeData[1], "set");
            // console.log(localData);
            // console.log(treeData);

            return treeData;
        }
    },
    watch: {
        activeComponent(guid) {
            this.selected = guid;
        }
    },
    methods: {
        ...mapMutations("components", ["setActiveComponent"]),
        transformPath(path) {
            const suffixes = ["m_", "c_", "s_", "a_"];
            const pathStart = path.slice(0, 2);

            return suffixes.includes(pathStart) ? path.slice(2) : path;
        },
        nodeClick(node) {
            const { key, header } = node;

            if (header === "control") {
                if (this.activeComponent !== key) {
                    this.selected = key;
                    this.setActiveComponent(key);
                }
            } else {
                const { modelTree } = this.$refs;
                const isExpanded = this.nodesExpanded.indexOf(key) !== -1;

                modelTree.setExpanded(key, !isExpanded);
            }
        },
        collapseElements() {
            this.$refs.modelTree.collapseAll();
        },
        expandElements() {
            this.$refs.modelTree.expandAll();
        },
        targetElement() {
            if (this.activeComponent) {
                const node = this.$refs.modelTree.getNodeByKey(this.activeComponent);
                const parentList = [...node.parentList];
                const [last] = parentList.splice(-1);

                // selectedNode = this.$refs.treeLayerScroll.$el.querySelector(".q-tree-node-selected"),
                // waitForClientRects = () => {
                //     let clientRects = selectedNode.getClientRects();
                //     if (clientRects.length) {
                //         let scrollRects = this.$refs.treeLayerScroll.$el.getClientRects()[0],
                //             scroll = clientRects[0].top - scrollRects.top - Math.round(scrollRects.height / 2);
                //
                //         if (scroll > 0) {
                //             this.$refs.treeLayerScroll.setScrollPosition(scroll);
                //         }
                //     } else {
                //         setTimeout(waitForClientRects, 1);
                //     }
                // };

                if (!this.nodesExpanded.includes(last)) {
                    this.nodesExpanded.push(last);
                }
                this.$nextTick(() => {
                    parentList.forEach(parent => {
                        if (!this.nodesExpanded.includes(parent)) {
                            this.nodesExpanded.push(parent);
                        }
                    });
                });
                // waitForClientRects();
            }
        },
        classList(guid) {
            const classes = ["text-caption"];

            if (this.activeComponent === guid) {
                classes.push("qf-node-active");
            }

            return classes;
        }
    }
};
